import { TMapAction, EMapActions } from './types';
import { ERouteStatus, ERoutingMode, IFragmentStore } from '../types';

export const initialState: IFragmentStore = {
  isOpen: false,
  isPanoramaOpen: false,
  zoom: 15,
  categories: [],
  panoramaError: false,
  isRouteMode: false,
  location: null,
  isRouteSearchOpen: false,
  route: {
    from: null,
    to: null,
    distance: '',
    routingTime: '',
    mode: ERoutingMode.Auto,
    status: ERouteStatus.Initial,
  },
};

export function mapFragmentReducer(state: IFragmentStore, action: TMapAction): IFragmentStore {
  switch (action.type) {
    case EMapActions.OpenMap:
      return { ...state, isOpen: true };
    case EMapActions.CloseMap:
      return { ...initialState };
    case EMapActions.OpenPanorama:
      return { ...state, isPanoramaOpen: true };
    case EMapActions.ClosePanorama:
      return { ...state, isPanoramaOpen: false };
    case EMapActions.SetActiveInfrastructureCategory:
      return {
        ...state,
        activeCategory: action.payload,
      };
    case EMapActions.SetZoom:
      return {
        ...state,
        zoom: action.payload,
      };
    case EMapActions.SetPanoramaError:
      return {
        ...state,
        panoramaError: action.payload,
      };
    case EMapActions.SetInfrastructureCategories:
      return {
        ...state,
        categories: action.payload,
      };
    case EMapActions.SetActiveInfrastructureItem:
      return {
        ...state,
        activeInfrastructureItem: action.payload,
      };
    case EMapActions.ActiveRouteMode:
      return { ...state, isRouteMode: true };
    case EMapActions.DeactiveRouteMode:
      return { ...state, isRouteMode: false };
    case EMapActions.OpenRouteSearchModal:
      return { ...state, isRouteSearchOpen: true };
    case EMapActions.CloseRouteSearchModal:
      return { ...state, isRouteSearchOpen: false };
    case EMapActions.SetLocation:
      return { ...state, location: action.payload };
    case EMapActions.SetRouteFrom:
      return {
        ...state,
        route: { ...state.route, from: action.payload },
      };
    case EMapActions.SetRouteTo:
      return {
        ...state,
        route: { ...state.route, to: action.payload },
      };
    case EMapActions.SetRouteInfo:
      return {
        ...state,
        route: { ...state.route, ...action.payload },
      };
    case EMapActions.SetRouteBuildingLoading: {
      return {
        ...state,
        route: {
          ...state.route,
          status: ERouteStatus.Loading,
        },
      };
    }
    case EMapActions.SetRouteBuildingSucceed: {
      return {
        ...state,
        route: {
          ...state.route,
          status: ERouteStatus.Succeed,
        },
      };
    }
    case EMapActions.SetRouteBuildingFailed: {
      return {
        ...state,
        route: {
          ...state.route,
          status: ERouteStatus.Failed,
        },
      };
    }
    case EMapActions.SetRoutingMode:
      return {
        ...state,
        route: { ...state.route, mode: action.payload, distance: '', routingTime: '' },
      };
    case EMapActions.ResetRoute:
      return {
        ...state,
        location: null,
        route: {
          ...state.route,
          from: null,
          distance: '',
          routingTime: '',
        },
      };
    case EMapActions.SetCenter:
      return {
        ...state,
        center: action.payload,
      };
    default:
      return state;
  }
}
